<template>
    <div>
        <v-btn
            @click="toggleAddDialog()"
            class="info text--white"
            slot="activator"
        >Add Job
        </v-btn>
        <v-dialog
            :value="addJobDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Job</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleAddDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Name"
                                    v-model="addName"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveNewItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { FETCH_JOB_LIST, SAVE_NEW_JOB } from "@/store/job/actions.js";
import { RESET_DEFAULT_NEW_JOB, TOGGLE_NEW_JOB_DIALOG, UPDATE_ADD_JOB_FIELD } from "@/store/job/mutations.js";
import { required, } from 'vuelidate/lib/validators';
import { mapActions, mapMutations } from "vuex";
import EditTableFunctions from './../../ManagePersonnel/components/editTableFunctions';

    export default {
        name: "AddJobDialog",

        validations: {
            addName: {required},
        },

        mixins: [
            EditTableFunctions,
        ],

        computed: {
            addJobDialog: {
                get() {
                    return this.$store.state.job.addJobDialog;
                },
            },
            addName: {
                get() {
                    return this.$store.state.job.addJob.name;
                },
                set(value) {
                    this.updateNewValue('name', value);
                },
            },
            addNameErrors() {
                const errors = [];
                if (!this.$v.addName.$dirty) return errors;
                !this.$v.addName.required && errors.push('required.');
                return errors
            },
        },

        mounted() {
            if (this.jobId !== undefined) {
                this.resetNewItemToDefault();
                this.updateNewValue('jobId', this.jobId);
            }
        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_JOB_LIST,
                saveNewTableItemRecord: SAVE_NEW_JOB,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_JOB_DIALOG,
                // loadTableItemToEdit: LOAD_PERSON_SUMMARY_TO_EDIT,
                updateTableItemToAdd: UPDATE_ADD_JOB_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_JOB,
            }),
        }
    }
</script>

<style scoped>

</style>
